import React from "react";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "@/components/ui/sidebar.tsx";
import { SidebarLists } from "@/views/lists/SidebarLists.tsx";
import { useLocation } from "wouter";
import { LogoView } from "@/components/LogoView.tsx";
import { SettingsIcon } from "lucide-react";

const AppSidebar: React.FC = (props) => {
	// const isMobile = useIsMobile();
	// const {setOpenMobile} = useSidebar()
	// const [matchRoot] = useRoute("/");
	const [, setLocation] = useLocation();

	const handleSettings = () => {
		setLocation("/settings/account");
	};

	// useEffect(() => {
	//     if (matchRoot && isMobile) {
	//         setOpenMobile(true);
	//     }
	// }, [isMobile, matchRoot]);

	return (
		<Sidebar>
			<SidebarHeader>
				<LogoView size={60} />
			</SidebarHeader>
			<SidebarContent>
				<SidebarLists />
			</SidebarContent>
			<SidebarFooter>
				<div>
					<SettingsIcon
						width={20}
						height={20}
						className={"cursor-pointer"}
						onClick={handleSettings}
					/>
				</div>
			</SidebarFooter>
		</Sidebar>
	);
};

export { AppSidebar };
